export enum EThemeSettings {
    buttonsSettings = 'buttonsSettings',
    colorsSettings = 'colorsSettings',
    fontsSettings = 'fontsSettings',
}
